import React from 'react';
 import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
 import HomePage from './pages/HomePage';
 import Blogs from './pages/Blogs';
 import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
// import Header from './components/Header';
import Navbar from './components/Nav/Navbar';
import Footer from './components/Footer';


function App() {
  return (
    <>
      
        <Router>
          <Navbar />
          <div>
            {/* Navigation links can go here, outside of Routes */}
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            </Routes>
          </div>
          <Footer />
        </Router>
      
    </>
  );
}

export default App;